module.exports = firebaseui.css;